var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['block.cmpMediaCarousel'] = (function () {
    'use strict';

    const initialize = (widget) => {

        const carousel = widget.querySelector(".splide");
        if (!carousel) return;

        const splideOptions = {
            type: "loop",
            focus: "center",
            pagination: false,
            autoWidth: true
        };

        App.Helpers.splideFallback(
            carousel,
            splideOptions,
            function (splide) {
                splideEventBindings(splide, carousel);
            }
        );
    };

    const splideEventBindings = (splide, carousel) => {

        const statusEl = carousel.querySelector(".splide__status");
        if (!statusEl) return;

        const currentEl = statusEl.querySelector(".current");
        const dividerEl = statusEl.querySelector(".divider");
        const totalEl = statusEl.querySelector(".total");

        splide.on('mounted', function () {
            if (currentEl) currentEl.textContent = "1";
            if (dividerEl) dividerEl.textContent = "/";
            if (totalEl) totalEl.textContent = splide.length;

            App.CmpMultiMedia.transcriptAlignment(carousel);
        });

        splide.on('resize', function () {
            App.CmpMultiMedia.transcriptAlignment(carousel);
        });

        splide.on('move', function (newIndex) {
            if (currentEl) currentEl.textContent = newIndex + 1;

            const videos = carousel.querySelectorAll(".cmp--multiMedia__video iframe");
            videos.forEach((iframe) => {
                const multiMedia = iframe.closest(".cmp--multiMedia__video");
                if (multiMedia) {
                    App.CmpMultiMedia.stop(multiMedia);
                }
            });
        });
    };

    return {
        initialize
    };

})();